import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DateTime } from "luxon";
import { apiClient } from "../service/tekkr-service";
import { useProject } from "../project";

interface Input {
    startDate: string;
    endDate: string;
}

export function useUpdateDeliverableTimelineMutation(workstreamId: string, deliverableId: string) {
    const { project } = useProject();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (input: Input) => {
            await apiClient.updateDeliverableTimelines({
                params: {
                    projectId: project.id,
                },
                body: {
                    updates: [
                        {
                            workstreamId,
                            deliverableId,
                            startDate: DateTime.fromISO(input.startDate).toISODate()!,
                            endDate: DateTime.fromISO(input.endDate).toISODate()!,
                        },
                    ],
                },
            });
        },
        onSuccess: async () => {
            queryClient.invalidateQueries({
                queryKey: ["project", project.id],
            });
            await queryClient.refetchQueries({
                queryKey: ["project-list"],
            });
        },
    });
}
